import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useAHAB } from '@/contexts/AHABProvider';
import find from 'lodash/find';
import { Select } from 'antd';
import createClearRenderView from '@/utils/createClearRenderView';

const renderCleanValue = createClearRenderView();

const MunicipalityAHABSelect = ({ value, onChange, onChangeFullObject, ...rest }) => {
  const currentValue = typeof value === 'object' ? Number(value?.pk) : Number(value);
  const { isLoadingMunicipalities, municipalities } = useAHAB();
  
  const onSelectionChange = useCallback((value, option) => {
    onChange && onChange(value);
    onChangeFullObject && onChangeFullObject(option);
  }, [onChange, onChangeFullObject]);
  
  const options = useMemo(() => {
    if (municipalities && !isLoadingMunicipalities) {
      return municipalities.map(item => {
        return { value: item?.pk, title: item?.municipio, key: item?.pk, label: item?.municipio };
      });
    }
    return [];
  }, [isLoadingMunicipalities, municipalities]);
  
  return (
    <div className={'w-full'}>
      <Select
        loading={isLoadingMunicipalities}
        options={options}
        showSearch
        filterOption={true}
        optionFilterProp={'title'}
        value={currentValue || null}
        allowClear={true}
        onChange={onSelectionChange}
        {...rest}
      />
    </div>
  );
};

MunicipalityAHABSelect.propTypes = {
  onChange: PropTypes.func,
  onChangeFullObject: PropTypes.func,
  value: PropTypes.any,
  filters: PropTypes.any
};

export const MunicipalityAHABView = ({ value: pk }) => {
  const { isLoadingMunicipalities, municipalities } = useAHAB();
  
  const currentValue = useMemo(() => {
    if (!isLoadingMunicipalities) {
      return renderCleanValue(find(municipalities, { 'pk': Number(pk) })?.municipio);
    }
  }, [isLoadingMunicipalities, municipalities, pk]);
  
  return (
    <div className={'w-full'}>
      {currentValue}
    </div>
  );
};
MunicipalityAHABView.propTypes = {
  value: PropTypes.any
};

export default memo(MunicipalityAHABSelect);

